import {GlobalPopupElement, PopupElement, setNoteElementLoader} from '@acng/frontend-discovery';
import {createDiv} from '@acng/frontend-bounty';
import {Feature} from 'acng/core/model/feature';

const name = 'layout';
export default name;
export const layoutFeature = new Feature(name, false);

layoutFeature.defineElement('onsw-popup', PopupElement);
layoutFeature.defineElement('onsw-global-popup', GlobalPopupElement);

setNoteElementLoader(async (severity, message) =>
  (await layoutFeature.template('note')).apply(createDiv(severity), (template, div) => {
    div.dataset.popupClose = '';
    template.textNodes.message.nodeValue = message;
  })
);

/*
defineController('popup', async () => (host, value) => {
  console.warn('POPUP', {host, value});
  return {
    [construct]: connectPopupController,
  };
});

defineController('dropdown', async () => () => ({
  [construct]: createDropdown,
}));
*/
